@if (pwa.isIncognito) {
  <ion-row class="ion-text-center">
    <ion-col size="12" class="ion-text-center ion-padding-horizontal ion-no-padding-bottom">
      <ion-label class="ion-text-wrap ion-text-uppercase" color="white" translate>COMMON.ALERT</ion-label>
    </ion-col>

    <ion-col size="12" class="ion-padding-horizontal">
      <ion-label class="ion-text-wrap" color="white" [innerHTML]="incognitoModeLabel"></ion-label>
    </ion-col>
  </ion-row>
}
